export default __webpack_public_path__ + "static/media/shortlist-icon.f2ffeeba.svg";